export default __webpack_public_path__ + "static/de-map-62ce76b3541648176a27c4df5b8126b3.png";